import React, {PureComponent} from 'react';
import './style.css';
import {Link} from "react-router-dom";

export default class ProductItem extends PureComponent {
	render() {
		return (
			<Link to={`/products?categoryId=${this.props.categoryId}&id=${this.props.id}`}>
				<div className="com-productitem">
					<div className="img-cover">
						<img className="img" src={this.props.img} alt="product"/>
					</div>
					<div className="info">
						<div className="name">{this.props.name}</div>
					</div>
				</div>
			</Link>
		);
	}
}


// WEBPACK FOOTER //
// ./src/03-components/ProductItem/index.js